import envSrv from '@/services/env-service.js'

export default function useSearchService() {
  function getVehicleDatesDataManagerSegregationKey(clientId) {
    if (!clientId) {
      throw new Error('useSearchService clientId required')
    }
    return (
      envSrv.getEnvName() + '_' + clientId
      //(rootGetters['auth/toClientId'] || rootGetters['auth/clientId'])
    )
  }

  return {
    getVehicleDatesDataManagerSegregationKey,
  }
}
